module.exports = __webpack_public_path__ + "img/sport.f28a5634.svg";